<template>
  <div class="extra_banners extra--mobile">
    <div class="row">
      <div v-for="banner in extra_banners" class="col-sm-12 extra_banner position-relative">
        <a :href="banner.link" :title="banner.title">
          <picture>
            <source :srcset="banner.image.webp" type="image/webp">
            <img :src="banner.image.source"
                 alt="image"
                 data-sizes="auto"
                 width="300"
                 height="300"
                 class="img mx-auto lazyload"
            >
          </picture>
          <!-- Text Wrapper -->
          <div class="banner-text">
            <h2>{{ banner.title }}</h2>
            <p>{{ banner.subtitle }}</p>
          </div>
        </a>
      </div>
    </div>
  </div>

  <div class="extra_banners extra--desktop">
    <div class="row">
      <div v-for="banner in extra_banners" class="col-sm-12 extra_banner position-relative mb-5">
        <a :href="banner.link" :title="banner.title">
          <picture>
            <source :srcset="banner.image.webp" type="image/webp">
            <img :src="banner.image.source"
                 alt="image"
                 data-sizes="auto"
                 width="350"
                 height="350"
                 class="img mx-auto lazyload"
            >
          </picture>
          <!-- Text Wrapper -->
          <div class="banner-text">
            <h2>{{ banner.title }}</h2>
            <p>{{ banner.subtitle }}</p>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:  "Extras",
  props: ['extra_banners'],
}
</script>

<style scoped>

.extra_banner {
  position: relative;
}

.banner-text {
  position: absolute;
  bottom: 10%;
  left: 5%;
  color: white;
  text-transform: uppercase;
  width: 80%; /* Control the width of the text box */
  margin-left: 30px;
}

.banner-text h2 {
  font-size: 18px; /* Adjust the font size */
  font-weight: bold;
  line-height: 1.2; /* Adjust line height for better text wrapping */
  word-wrap: break-word; /* Ensure words wrap to the next line */
}

.banner-text p {
  font-size: 16px; /* Adjust the subtitle font size if needed */
}
</style>
